import { LitElement, html, ref, createRef, utils } from '@hh/global.js'
const { debounce } = utils
class HHMobilePredictiveSearch extends LitElement {
  $form = createRef()

  constructor() {
    super()

    this.route = '/search'
    this.cachedResults = {}
    this.form = this.querySelector('form')
    this.input = this.querySelector('#Search-In-Modal--mobile')
    this.clearButton = this.querySelector('.mobile-search__clear')
    this.suggestionButtons = this.querySelectorAll('.search-modal__suggested button')
    this.resetMenuButton = this.querySelector('#backtoMenu')
    this.setupEventListeners()
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('mobile-results', false);
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this))
    this.input.addEventListener('focusin', this.onFocus.bind(this))
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )
    this.resetMenuButton.addEventListener('click', this.resetMenu.bind(this))

    this.suggestionButtons.forEach((button) => {
      button.addEventListener(
        'click',
        ((event) => {
          event.preventDefault()
          this.input.nextElementSibling.style.transform = "translateY(-9px)";
          if (button.dataset.term.length) {
            this.input.value = button.dataset.term
            this.updateTermButtonState(button)
            this.onChange(event)

          }
        }).bind(this)
      )
    })
  }

  resetMenu() {
    this.querySelector('.mobilesuggestions').style.display = 'none'
    this.querySelector('#mobile-header-results').style.display = 'none'
    this.querySelector('#mobile-searchresults-container').style.display = 'none'
    this.querySelector('.backtoMenu').style.display = 'none'
    this.onClear()
  }

  getQuery() {
    return this.input.value.trim()
  }

  onFormSubmit(event) {
    event.preventDefault();
  }

  onFocus() {
    this.querySelector('.backtoMenu').style.display = 'block'
    this.querySelector('.mobilesuggestions').style.display = 'block'
    this.querySelector('#mobile-header-results').style.display = 'block'
    this.querySelector('#mobile-searchresults-container').style.display = 'block'
    const searchTerm = this.getQuery()
    if (!searchTerm.length) return
    if (this.getAttribute('mobile-results') === 'true') {
      this.open()
    } else {
      this.getResult(searchTerm)
    }

  }

  updateTermButtonState(button) {
    if (this.getQuery() === button.dataset.term) {
      button.setAttribute('disabled', true)
    }
  }

  onChange() {
    const searchTerm = this.getQuery()

    if (!searchTerm.length) {
      this.close(true)
      return
    }

    if (searchTerm.length < 1) {
      this.close()
      return
    }

    this.resetSuggestions()
    this.getResult(searchTerm)
  }

  resetSuggestions() {
    this.suggestionButtons.forEach((button) => {
      if (this.getQuery() !== button.dataset.term) {
        button.removeAttribute('disabled')
      }
    })
  }

  onClear() {
    this.input.value = ""
    this.onChange()
  }

  getResult(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    if (this.cachedResults[queryKey]) {
      this.renderResults(this.cachedResults[queryKey])
      return
    }

    fetch(
      `${this.route}?q=${encodeURIComponent(searchTerm)}&type=product&section_id=header`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.mobile-results').innerHTML
        this.cachedResults[queryKey] = resultsMarkup
        this.renderResults(resultsMarkup)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  renderResults(resultsMarkup) {
    this.querySelector('#mobile-searchresults-container').innerHTML = resultsMarkup
    this.setAttribute('mobile-results', true)
    this.setLiveRegionResults()
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true)
  }

  setLiveRegionResults() {
    this.removeAttribute('loading')
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('mobile-results');
      this.querySelector('#mobile-searchresults-container').innerHTML = '';
    }

    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }

  render() {
    return html`
          <slot name="heading"></slot>
          <slot name="back-to-menu"></slot>
          <slot name="form" @clearSearch="${this.onClear}"></slot>
          <slot name="mobile-suggestion"></slot>
          <slot name="mobile-results"></slot>
          <slot name="mobile-header-results"></slot>
          `
  }

}

customElements.define('hh-mobile-predictive-search', HHMobilePredictiveSearch)
